import React from 'react';
import { FormattedMessage } from 'react-intl';

import Text from 'ui/Text';
import twitterLogo from 'assets/twitter-logo-white.png';
import linkedInLogo from 'assets/linkedin-logo-white.png';
import facebookLogo from 'assets/facebook-logo-white.png';

const Footer = () => (
  <div className="footer full-width">
    <ul className="footer-links flex justify-content-center bg-dark-grey">
      <li>
        <a
            href="https://www.linkedin.com/company/epic-africa-llc"
            target="_blank"
            rel="noopener noreferrer"
        >
          <img src={linkedInLogo} className="icon" alt="LinkedIn Logo" />
        </a>
      </li>
      <li>
        <a href="https://twitter.com/EPIC_Africa_" target="_blank" rel="noopener noreferrer">
          <img src={twitterLogo} className="icon" alt="Twitter Logo" />
        </a>
      </li>
      <li>
        <a
            href="https://www.facebook.com/EPICAfrica.Fdn/"
            target="_blank"
            rel="noopener noreferrer"
        >
          <img src={facebookLogo} className="icon" alt="Facebook Logo" />
        </a>
      </li>
    </ul>
    <div className="footer-contacts bg-secondary-black text-center">
      <Text type="tiny" modifiers="uppercase light-grey contact-one center-block">
        <a
            className="almost-white"
            href="http://www.epic-africa.org/contact-us/"
            target="_blank"
            rel="noopener noreferrer"
        >
          <FormattedMessage id="Footer.ContactUs" defaultMessage="Contact Us" />
        </a>
      </Text>
      <Text type="tiny" modifiers="light-grey uppercase contact-two center-block">
        <FormattedMessage
            id="Footer.Location"
            defaultMessage="EPIC-AFRICA FOUNDATION, LIBERTY
            EXTENSION 6, LOT NO. 46, CITE DE JEUNE, CADRE LEBOU,
            BP 45581 DAKAR FANN, SENEGAL ADMIN@EPIC-AFRICA.ORG"
        />
      </Text>
      <span className="fake-border fake-border__underline bg-light-grey center-block" />
      <br/>
      <Text type="tiny" modifiers="light-grey uppercase contact-two center-block">
        Developed by iHub Software Consulting
      </Text>
    </div>
  </div>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/HomePage/Footer.js